var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('headNavBar',{attrs:{"title":"系统维护"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }